import { z } from 'zod'

const ZSendStatementEmail = z.object({
  email: z.string().email(),
})

export const ZSendStatementEmailRequest = z.object({
  contractId: z.number(),
  body: ZSendStatementEmail,
})

export type TSendStatementEmail = z.infer<typeof ZSendStatementEmail>
export type TSendStatementEmailRequest = z.infer<
  typeof ZSendStatementEmailRequest
>
